import React from 'react';
import { motion } from 'framer-motion';
import Seo from '../components/Seo';
import { PAGE_COPY } from '../data/seoContent';
import PDCProductSection from '../components/PDCProductSection';
import CallForPricingGrid from '../components/CallForPricingGrid';
import { CLEARWATER_SWIM_SPAS } from '../data/clearwaterSpas';
import { PDC_SPAS_PRODUCTS } from '../data/pdcSpas';
import { itemListLd } from '../data/structuredData';

const SwimSpasPage = () => {
  return (
    <>
      <Seo page="/swim-spas" jsonLd={itemListLd('Swim spas in Naples, FL', '/swim-spas', [
        ...PDC_SPAS_PRODUCTS.filter((p) => p.category === 'swim-spas').map((p) => ({ brand: 'PDC Spas', name: p.name, url: `/pdc-spas/${p.id}`, image: p.images?.[0] })),
        ...CLEARWATER_SWIM_SPAS.map((p) => ({ brand: 'ClearWater Spas', name: p.name, url: '/clearwater-spas', image: p.image })),
      ])} />

      <div className="pt-36 pb-20" style={{ background: 'linear-gradient(180deg, #ffffff 0%, #E0FFFF 20%, #AFEEEE 50%, #98FB98 80%, #F0FFF0 100%)' }} data-testid="swim-spas-page">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-8"
          >
            <div className="flex items-center gap-2 mb-2">
              <span className="text-2xl">🇺🇸</span>
              <span className="text-sm font-semibold text-[#F88200] uppercase tracking-wider">American Made & Proud of It</span>
            </div>
            <h1 className="font-['Barlow_Condensed'] text-4xl md:text-6xl font-bold uppercase text-[#0E3D95] mb-4">
              Swim Spas in Naples, FL
            </h1>
            <p className="text-lg text-slate-600 max-w-4xl" data-testid="page-intro">
              {PAGE_COPY.swimSpas}
            </p>
          </motion.div>

          {/* PDC Spas Swim Spas Section */}
          <PDCProductSection
            category="swim-spas"
            heading="PDC Spas Swim Spas"
            blurb="Voted Swim Spa of the Year — patented TruSwim® propulsion, powerful Summit™ & Synergy™ jetted currents, and the family-friendly Splash Series. Built to order in the USA. Click any model to explore colors and finishes."
          />

          <CallForPricingGrid
            eyebrow="Clearwater Spas · Swim Series"
            title="Clearwater Swim Spas"
            subtitle="The XL16000 and XL14000 — River Jet resistance swimming plus full hydrotherapy seating."
            items={CLEARWATER_SWIM_SPAS}
            testId="clearwater-swim-spas"
          />

          {/* Swim Spas Video Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-16"
          >
            <div className="text-center mb-8">
              <h2 className="font-['Barlow_Condensed'] text-3xl md:text-4xl font-bold text-[#0E3D95] mb-4">
                Discover Swim Spas
              </h2>
              <p className="text-lg text-slate-600 max-w-3xl mx-auto">
                Learn about the benefits of swim spas and how they can transform your home into a complete wellness destination.
              </p>
            </div>
            <div className="max-w-4xl mx-auto">
              <div className="relative aspect-video rounded-lg overflow-hidden shadow-2xl">
                <video
                  controls
                  className="w-full h-full object-contain bg-black"
                >
                  <source src="/videos/swim-spas.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </>
  );
};

export default SwimSpasPage;
